import React, { useEffect, useMemo, useState } from "react";
import { SignedUpBusinesses } from "../../pages";
import { BusinessController } from "../../controllers";
import { useStores } from "../../stores";
import { useNavigate } from "react-router-dom";
import constant from "../../utils/constant";

const SignedUpBusinessesContainer = () => {
  const [ViewMoreModal, setViewMoreModal] = useState(false);
  const [ deleteSubdomainUrlModal, setDeleteSubdomainUrlModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const { businessStore } = useStores();
  const { signedUpBusinesses, signedupBusinessesAnalysis } =
    businessStore || {};
  const [infoModal, setInfoModal] = useState("stage1");

  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [tableList, setTableList] = useState("");
  const [isOnlyParent, setIsOnlyParent] = useState(false);
  const [isFash, setIsFash] = useState(false);
  const [subscriptionModal, setSubscriptionModal] = useState(false);
  const [updateBusinessModal, setUpdateBusinessModal] = useState(false);

  const navigate = useNavigate();

  const signedUpBizTableQuery = useMemo(() => {
    let queryString = `offset=${currentPage + 1}&limit=${limit}&onlyParent=${isOnlyParent}&isFash=${isFash}`;
    if (tableList && tableList !== "") {
      queryString += `&tableList=${tableList}`;
    }
    return queryString;
  }, [currentPage, limit, isOnlyParent, isFash, tableList]);

  const { isLoading, data, isFetching } =
    BusinessController.useGetAllSignedBusinesses(
      signedUpBizTableQuery,
      filterQuery,
      searchQuery
    );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const options1 = [
    {
      label: "Approve",
      value: "Approve",
    },
    {
      label: "View More",
      value: "View More",
    },
    {
      label: "List Invoices",
      value: "List Invoices",
    },
    {
      label: "Give Subscription",
      value: "Give Subscription",
    },
    {
      label: "Update Business",
      value: "Update Business",
    },
  ];

  const options2 = [
    {
      label: "Suspend",
      value: "Approve",
    },
    {
      label: "Delete Website Url",
      value: "Delete Website Url",
    },
    {
      label: "View More",
      value: "View More",
    },
    {
      label: "List Invoices",
      value: "List Invoices",
    },
    {
      label: "Give Subscription",
      value: "Give Subscription",
    },
    {
      label: "Update Business",
      value: "Update Business",
    },
  ];

  useEffect(() => {
    const setBusinesses = async () => {
      let query = `isFash=${isFash}`;
      setLoading(true);
      await Promise.all([
        // BusinessController.getAllSignedBusinesses(query),
        BusinessController.getSignedUpBusinessesAnalysis(query),
      ]);
      setLoading(false);
    };
    setBusinesses();
  }, [businessStore, isFash]);

  const handleApprove = () => {
    setViewMoreModal(true);
    setInfoModal("stage2");
  };

  const handleDeleteSubdomain = () => {
    setDeleteSubdomainUrlModal(true);
  };

  const handleViewMore = () => {
    setViewMoreModal(true);
    setInfoModal("stage1");
  };

  const handleListInvoices = () => {
    navigate(constant.Routes.InvoiceReceipt);
  };
  const handleGiveSubscription = () => {
    setSubscriptionModal(true);
  };

  const handleUpdateBusiness = () => {
    setUpdateBusinessModal(true);
  };

  const closeModal = () => {
    setViewMoreModal(false);
    setDeleteSubdomainUrlModal(false)
    setSubscriptionModal(false);
    setUpdateBusinessModal(false);
  };

  return (
    <SignedUpBusinesses
      options1={options1}
      options2={options2}
      loading={loading}
      infoModal={infoModal}
      setInfoModal={setInfoModal}
      signedUpBusinesses={signedUpBusinesses}
      closeModal={closeModal}
      ViewMoreModal={ViewMoreModal}
      deleteSubdomainUrlModal={deleteSubdomainUrlModal}
      handleViewMore={handleViewMore}
      handleApprove={handleApprove}
      handleListInvoices={handleListInvoices}
      handleDeleteSubdomain={handleDeleteSubdomain}
      signedupBusinessesAnalysis={signedupBusinessesAnalysis}
      isFetching={isFetching}
      signedUpBizdata={data}
      isLoading={isLoading}
      limit={limit}
      onLimitChange={onLimitChange}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setFilterQuery={setFilterQuery}
      setSearchQuery={setSearchQuery}
      setTableList={setTableList}
      setIsOnlyParent={setIsOnlyParent}
      isOnlyParent={isOnlyParent}
      isFash={isFash}
      setIsFash={setIsFash}
      handleGiveSubscription={handleGiveSubscription}
      subscriptionModal={subscriptionModal}
      handleUpdateBusiness={handleUpdateBusiness}
      updateBusinessModal={updateBusinessModal}
    />
  );
};
export default SignedUpBusinessesContainer;
